import GenerateRequest from './resources';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();

export default {
  async addUpdateCatalog(params) {
    try {
      await checkLicenseExpiry();
      const updatedCatalog = await req.post('items/addCatalog', params);
      return updatedCatalog.data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async archiveCatalog(params) {
    try {
      await checkLicenseExpiry();
      const { data: archivedCatalog } = await req.get('items/archiveCatId', { params });
      return archivedCatalog;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async unArchiveCatalog(params) {
    try {
      await checkLicenseExpiry();
      const { data: unArchivedCatalog } = await req.get('items/unArchiveCatId', { params });
      return unArchivedCatalog;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async getQtyCalData(params) {
    try {
      await checkLicenseExpiry();
      const data = await req.post('items/getCalData', params);
      return data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async getAssemblyParts(params) {
    try {
      await checkLicenseExpiry();
      const data = await req.post('catalogue', params);
      return data.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async addAssemblyParts(params, type) {
    try {
      await checkLicenseExpiry();
      const { data: updatedAssemblyParts } = await req.post(`catalogue/add/${type}`, params);
      return updatedAssemblyParts;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async updateAssemblyParts(params) {
    try {
      await checkLicenseExpiry();
      const updatedAssemblyParts = await req.post(`catalogue/edit/${params._id}`, params);
      return updatedAssemblyParts;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async archive(params, type) {
    try {
      await checkLicenseExpiry();
      const { data: archivedCatalog } = await req.post(`catalogue/archive/${type}`, { params });
      return archivedCatalog;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async unarchive(params, type) {
    try {
      await checkLicenseExpiry();
      const { data: unarchivedCatalog } = await req.post(`catalogue/unarchive/${type}`, { params });
      return unarchivedCatalog;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async checkCatIds(params) {
    try {
      await checkLicenseExpiry();
      const data = await req.post('catalogue/checkCatId', params);
      return data.data;
    } catch (e) {
      throw e.data.message;
    }
  },
  async getSuperAssemblies() {
    try {
      await checkLicenseExpiry();
      const data = await req.get('catalogue/getSuperAssemblies');
      return data;
    } catch (error) {
      throw error.data.message;
    }
  },
  async getAssemblyPartsData(params) {
    try {
      await checkLicenseExpiry();
      let data;
      if (params.catId && params.catId.length > 100) {
        data = await req.post('catalogue/assemblyPartsData', params);
      } else {
        data = await req.get('catalogue/assemblyPartsData', { params });
      }
      return data.data;
    } catch (error) {
      throw error.data.message;
    }
  },
  /* API to fetch all the existing CATALOG ID's */
  async getAllCatIds() {
    try {
      await checkLicenseExpiry();
      const data = await req.get('catalogue/allCatIds');
      return data;
    } catch (e) {
      throw e.data.message;
    }
  },
};
